<template>
    <b-modal
        id="copy-group-modal"
        v-model="modal"
        ref="copy-group-modal"
        title="Groep Kopiëren"
        :ok-disabled="!name"
        ok-title="Opslaan"
        cancel-title="Annuleren"
        cancel-variant="outline-primary"
        @ok="onOk()"
        modal-class="apprentice-default-modal">
        <div class="project-title">
            <b-form-group
                label="Titel:"
                label-for="group-copy-title-input">
                <b-form-input
                    id="group-copy-title-input"
                    v-model="name"
                    placeholder="Titel"></b-form-input>
            </b-form-group>
        </div>

        <div class="project-season">
            <b-form-group
                class="project-season-group"
                label="Schooljaar:"
                label-for="group-copy-season-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="group-copy-season-select"
                    v-model="season_id">
                    <option
                        v-for="season in seasonsIn"
                        :value="season.id">
                        {{ season.season }}
                    </option>
                </b-form-select>
            </b-form-group>

            <div class="project-start-date">
                <b-form-group
                    label="Startdatum:"
                    label-for="group-copy-startdate-picker">
                    <b-form-datepicker
                        class="apprentice-date-picker btn-date-group"
                        id="group-copy-startdate-picker"
                        v-model="start_date"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        locale="nl"
                        aria-controls="Kies een datum"
                        label-reset-button="reset"
                        today-variant="primary"
                        nav-button-variant="primary"
                        label-no-date-selected="Geen datum geselecteerd"
                        menu-class="datedropdown"
                        @input="updateDate($event, 'start')"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
                    </b-form-datepicker>
                </b-form-group>

                <b-form-group label="Starttijd:">
                    Vanaf deze datum wordt het project weergegeven aan leerlingen.
                    <design-2021-apprentice-timepicker-component
                        v-model="start_time"></design-2021-apprentice-timepicker-component>
                </b-form-group>
            </div>

            <div class="project-end-date">
                <b-form-group
                    label="Einddatum:"
                    label-for="group-copy-enddate-picker">
                    <b-form-datepicker
                        class="apprentice-date-picker btn-date-group"
                        id="group-copy-enddate-picker"
                        v-model="end"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        locale="nl"
                        today-variant="primary"
                        nav-button-variant="primary"
                        aria-controls="Kies een datum"
                        label-reset-button="reset"
                        label-no-date-selected="Geen datum geselecteerd"
                        menu-class="datedropdown"
                        @input="updateDate($event, 'end')"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
                    </b-form-datepicker>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import moment from 'moment';
export default {
    name: 'design-2021-quick-copy-group-modal-component',
    props: ['seasonsIn'],
    data() {
        return {
            group: null,
            name: null,
            course_id: null,
            season_id: null,
            start_date: null,
            start_time: null,
            end: null,
            modal: false,
        };
    },
    methods: {
        updateDate(event, type) {
            if (type === 'start') {
                this.start_date = event;
            } else {
                this.end = event;
            }
        },
        onOk() {
            this.alert.saving();

            if (this.start_date === null) {
                this.start = this.group.start;
            }

            let startDateTime = this.start_date;
            if (this.start_time) {
                startDateTime = this.start_date + ' ' + this.start_time;
            }

            if (this.end === null) {
                this.end = this.group.end;
            }

            const data = {
                title: this.name,
                season_id: this.season_id,
                start_date: startDateTime,
                end_date: this.end,
            };

            this.axios.post(this.routes.baseUrl() + '/group/' + this.group.group_id + '/copy', data).then(
                (response) => {
                    this.$emit('addGroup', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError();
                },
            );
        },
        show(groupIn) {
            this.group = groupIn;
            this.name = groupIn.group_name;
            this.season_id = groupIn.season_id;
            let start = groupIn.start.split(' ');
            this.start_date = start[0];
            this.start_time = start[1];
            this.end = groupIn.end;
            this.modal = true;
        },
    },
};
</script>

<style scoped lang="scss">
input,
select {
    margin-bottom: 0;
}

.project-title,
.project-course {
    margin-bottom: $grid-gutter-width;
}

.project-season {
    display: flex;
    flex-direction: column;
    row-gap: $grid-gutter-width;
    justify-content: flex-start;
    align-items: flex-start;

    > div {
        width: 100%;
    }

    .form-group,
    .apprentice-date-picker {
        margin-bottom: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .project-season {
        flex-direction: row;
        flex-wrap: wrap;

        > div {
            width: auto;
        }

        .project-season-group {
            width: 100%;
            flex: 1 0 100%;
        }

        .project-start-date,
        .project-end-date {
            flex: 0 1 calc(50% - 15px);
        }

        .project-end-date {
            margin-left: auto;
        }
    }
}
</style>
